import { Component, HostBinding, Input, ViewChild } from '@angular/core'
import { BaseModal } from '@app/pages/base.modal'
import { IonContent, IonItem, IonLabel, IonList } from '@ionic/angular/standalone'
import { ValuePickerValue } from './value-picker.model.js'

@Component({
  selector: 'app-value-picker-modal',
  templateUrl: './value-picker.modal.html',
  styleUrls: ['./value-picker.modal.scss'],
  imports: [IonContent, IonLabel, IonItem, IonList],
})
export class ValuePickerModal extends BaseModal {
  className = 'ValuePickerModal'

  @Input()
  uid?: string

  @Input()
  values?: ValuePickerValue[]

  @Input()
  selected?: ValuePickerValue

  @Input()
  scrollTo?: ValuePickerValue

  @Input()
  alignRight?: boolean

  @Input()
  noGradient?: boolean = true

  @Input()
  set width(_width: string) {
    this._width = _width
  }

  @HostBinding('style.--picker-width')
  _width = ''

  @ViewChild(IonContent)
  content?: IonContent

  override ionViewDidEnter(): void {
    const item = this.selected || this.scrollTo

    if (!item) return

    const itemElem: HTMLElement | null = document.querySelector(
      `[uid="valuePickerItem--${item.value}"]`,
    )
    if (!itemElem) return

    void this.content?.scrollToPoint(0, itemElem.offsetTop - window.innerHeight / 2)
  }

  onSelected(value: ValuePickerValue, event: Event): void {
    event.stopPropagation()

    if (value.disabled) return

    this.closeModal(value)
  }

  closeModal(params?: any): void {
    void this.dismissModal(params)
  }
}
